enum CategoryBusiness {
  RMA = 'RMA',
  AFFAIRE = 'AFFAIRE',
}

export default CategoryBusiness;
